/**
 * Created by Ning Jiang on 2/21/2018.
 */

import {IParsedStackedSymbolName, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";

export class WildNudgeHelper {

    public static findStackedSymbolBottomPositionFromReelData(findingName:string, reelId:number, reelData:string[], startIndex:number):number {
        for(let i:number = startIndex; i < reelData.length; i++) {
            const symName:string = reelData[i];
            const stackedSymName:IParsedStackedSymbolName = StateReelSymbol.parseStackedSymbolName(symName, reelId);
            if(stackedSymName.isStacked && stackedSymName.symName === findingName) {
                return i - 1 + (4 - stackedSymName.index - 1);
            }
        }
        return Number.NaN;
    }
}